import type { ProductCardData } from '@chewy/chat-library-common';
import { WidgetContainer, ProductImage, WidgetOverlayButton } from '@chewy/chat-library-components';

interface ProductCardProps {
  data: Partial<ProductCardData>;
  isSelectable?: boolean;
  isSelected?: boolean;
  isUnselected?: boolean;
  onSelect?: () => void;
}

export default function ProductCard({ data, isSelectable = false, isSelected, isUnselected, onSelect }: ProductCardProps) {
  const imageUrl = data.imageUrl ?? '';
  const name = data.name ?? 'Product image';
  const quantity = data.quantity;

  return (
    <WidgetContainer
      isSelectable={isSelectable}
      isSelected={isSelected}
      isUnselected={isUnselected}
      onSelect={onSelect}
      data={data}
    >
      <ProductImage
        imageUrl={imageUrl}
        name={name}
        quantity={quantity}
      />
      {isSelectable && (
        <WidgetOverlayButton
          text=""
          ariaLabel={`Select ${name}`}
        />
      )}
    </WidgetContainer>
  );
}
